var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_1224_1468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1224_1468",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1224_1468",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1224_1468",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA+BJREFUWEfFl11oHFUUx3/nJjb4geBDKVKFqihiQBBBWqwaUSoIKirBz85u1Ye2Itho6c6ktAkmO7GtbVXwA6SZ2W21KgSpglQKLUKLXwXRkhcfIio04EMEDVhq7pE7u9nsbnc3sxvB+7R77zn/85sz95y5V/ifhzSNH2b7DLZfxaxG9WqgW5AvrOopVL5kMPq+xnfUuxlj7hP0DuBOYAZ0UjA/WbFHyRU+bxTrQoC8t8aIbFHobwon/KFWhgmi/YlNPvuIiL4DLG/mI3DIqn2ToPh1tU0twKuZe8RyrE7kV4TTokwprAbWzK8LfAA6o8jmKp/T4rIkoiArFL0BuGV+Xefmbmf7wVNVGuWfYbZP0OOVBWG/RQ6Qi36sASrZ7QT66kBPKDKMH52omR/afJnpmQ0U/NK8nlFr1zF48Kz7V8pAbfBpVdlEEH3Scn+OekNixIGgVocZLAy1tM9n14toocSgExoUHq0AmNA7rMhjpTV9gKDwWariCLNZYBY/+jiV/Vg2J6phEkf0frcxhfDJa4WLJoEe4FP14wdTiXVitHv9pfKPOQOsmo8lVKWmrafvBAAwobdLka1JFui+XsxYZp8qLwLT6sdXdqib3i2/4SYR+1ECcE7WioQZVxKutL5SP66UWHrFDix3PnU5PcuuIhifdABT7p2IcNjm4ic6kFuSiwM4BywT0TGbK5RrdUmabTk7gO+AWwX50PrR4215pzUu94xGm1xMmB1TdBvws/rxNWk127GTMOM6bF+jhiWE3sOCTJSakOl1G6Md8TS2rQFGvJXSJb8lbVHYZXOxy8Z/OloDuOYwltmtysulLLCWID65JALXoq113S4ZYuSuyiuoFhbzQ+ljNPrcCuk6fxLlOpQjGsQPdQwQZlcJ6ko7zfh94TwQZjcK+naSBeRZ/OhAGoVGNibMjCu4D1XLIRDVHEgkzBwF1pVehXgEUXExkTTri+6BishCn+5NIEQ3kiu8myZIK5v0AE6lHkL1JYLC3qVAtAfQCALdgV94pVMIk/feUJEXFHkeP3qrphCaitZlwm0Yy/kB/Pdn2gbJb1iOaC/dc9+ytTibDmAhE68D9yZOyjcKA037xIi30nTJDmv17KJnxDJF84vJPObQkDE9U3sUtpSn/lR0AL/wXk0mSi09D9xYLuW7LzghN0jd4gDzTqH3jCB7gCvclMA+68cD7rcJM/mFY3eydsj68dNpXlV6AKc24t0mXQmEu341GtNqCNgWj6cJXn6QtKZlu739F5u/L3lNhU21m0mLVnQ7ueIv7Si2l4Fq5fLlFZW/LHai/s6XFqJzgLQRFrH7F0Wzmr52rpJPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.83c1832f8ed9bfbf6dc0961a192e0a06.svg";
export { ForwardRef as ReactComponent };